import React, { useEffect, useRef, useState } from "react";

const StatusNoDD = ({ name }) => {
  const dropdownRef = useRef(null);

  const buttonRef = useRef(null);

  useEffect(() => {
    if (buttonRef.current) {
      buttonRef.current.style.setProperty(
        "border",
        "1px solid #245cea",
        "important"
      );
    }
  }, []);

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <button
        className="px-5 py-1 rounded-full border secondary_btn transition-all duration-500"
        ref={buttonRef}
      >
        {name}
      </button>
    </div>
  );
};

export default StatusNoDD;
